// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Variables for consistent theming */
:root {
  --primary-color: #2196f3;
  --primary-dark: #1976d2;
  --success-color: #2ecc71;
  --warning-color: #f1c40f;
  --danger-color: #e74c3c;
  --text-primary: #2c3e50;
  --text-secondary: #7f8c8d;
  --background-light: #f8f9fa;
  --border-color: #e0e0e0;
  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);
  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);
  --radius-sm: 4px;
  --radius-md: 8px;
  --radius-lg: 12px;
}

/* Enhanced table container */
.staff-table-container {
  background: white;
  border-radius: var(--radius-lg);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  margin: 28px auto;
  padding: 28px;
  transition: transform 0.3s ease;
  width: 90%;
  max-width: 1600px;
  overflow-x: auto;
  display: block;
  position: relative;
  left: 0;
  right: 0;
}

.staff-table-container:hover {
  transform: translateY(-2px);
}

/* Enhanced table styling */
.staff-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.95rem;
  min-width: 1200px;
  table-layout: fixed;
  margin: 0 auto;
}

.staff-table thead th {
  background: linear-gradient(to right, var(--background-light), white);
  padding: 18px;
  font-weight: 600;
  color: var(--text-primary);
  border-bottom: 2px solid var(--border-color);
  transition: background-color 0.3s ease;
}

.staff-table tbody tr {
  transition: background-color 0.3s ease;
  position: relative;
}

.staff-table tbody tr:hover {
  background-color: var(--background-light);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  transform: none;
}

.staff-table td {
  padding: 16px;
  border-bottom: 1px solid var(--border-color);
  vertical-align: middle;
  height: 72px;
}

/* Enhanced status badges */
.status {
  padding: 8px 14px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 0.8rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.status.valid {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
}

.status.unknown {
  background-color: rgba(189, 195, 199, 0.15);
  color: #7f8c8d;
}

.status.suspended {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
}

.status.disqualified {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
}

/* Points Indicator */
.points {
  padding: 4px 8px;
  border-radius: var(--radius-sm);
  font-weight: 500;
  min-width: 30px;
  text-align: center;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.points.low {
  background-color: rgba(46, 204, 113, 0.15);
  color: #27ae60;
}

.points.medium {
  background-color: rgba(241, 196, 15, 0.15);
  color: #f39c12;
}

.points.high {
  background-color: rgba(231, 76, 60, 0.15);
  color: #c0392b;
}

/* Action Buttons */
.actions-cell {
  width: auto;
  min-width: 200px;
  padding: 8px 16px 8px 8px;
  white-space: nowrap;
}

/* Update the action buttons container */
.action-buttons-container {
  display: flex;
  flex-direction: column;
  gap: 8px;
  align-items: stretch;
  max-width: 180px;
  margin-right: auto;
}

.primary-actions {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  width: 100%;
}

/* Update all action buttons to have consistent styling */
.view-details-btn,
.check-license-btn,
.archive-btn {
  padding: 8px 12px;
  border-radius: 4px;
  background-color: transparent;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  border: 1px solid;
  min-width: 70px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1 1;
}

/* View Details button styling */
.view-details-btn {
  border-color: #0d6efd;
  color: #0d6efd;
}

.view-details-btn:hover {
  background-color: #0d6efd;
  color: white;
}

/* Check License button styling */
.check-license-btn {
  border-color: #198754;
  color: #198754;
  background-color: transparent !important;
  width: 100%;
}

.check-license-btn:hover {
  background-color: #198754 !important;
  color: white;
}

.check-license-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: transparent !important;
  border-color: #6c757d;
  color: #6c757d;
}

/* Archive button styling */
.archive-btn {
  border-color: #dc3545;
  color: #dc3545;
}

.archive-btn:hover {
  background-color: #dc3545;
  color: white;
}

/* Focus states for all buttons */
.view-details-btn:focus,
.check-license-btn:focus,
.archive-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25);
}

/* Active states for all buttons */
.view-details-btn:active,
.check-license-btn:active,
.archive-btn:active {
  transform: scale(0.98);
}

/* Enhanced loading and empty states */
.loading-spinner,
.no-data {
  text-align: center;
  padding: 60px;
  color: var(--text-secondary);
  font-size: 1.1rem;
  background: linear-gradient(45deg, var(--background-light), white);
  border-radius: var(--radius-lg);
  margin: 28px;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }
  50% {
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.12);
  }
  100% {
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  }
}

/* Enhanced mobile responsiveness */
@media (max-width: 768px) {
  .staff-table-container {
    margin: 8px;
    padding: 8px;
    width: auto;
    max-width: 100%;
    box-sizing: border-box;
  }

  .staff-table {
    font-size: 0.85rem;
    width: 100%;
    box-sizing: border-box;
  }

  .staff-table thead {
    display: none;
  }

  .staff-table, 
  .staff-table tbody, 
  .staff-table tr, 
  .staff-table td {
    display: block;
    width: 100%;
    box-sizing: border-box;
  }

  .staff-table tr {
    margin-bottom: 16px;
    padding: 8px;
    border-radius: var(--radius-md);
    border: 1px solid var(--border-color);
    box-shadow: var(--shadow-sm);
    width: 100%;
    box-sizing: border-box;
  }

  .staff-table td {
    padding: 8px;
    height: auto;
    min-height: 40px;
    position: relative;
    width: 100%;
    box-sizing: border-box;
  }

  /* Completely restructured actions cell for mobile */
  td.actions-cell {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 8px;
    width: 100%;
    box-sizing: border-box;
    overflow: visible;
  }

  .actions-cell .check-license-btn,
  .actions-cell .view-details-btn,
  .actions-cell .delete-btn {
    width: 100%;
    box-sizing: border-box;
    min-width: 0;
    padding: 10px;
    margin: 0;
    font-size: 0.85rem;
  }

  .actions-cell .button-content {
    width: auto;
    min-width: 0;
    justify-content: center;
    white-space: normal;
  }

  /* Ensure no horizontal scroll on the container */
  .staff-table-container {
    overflow-x: hidden;
  }

  /* Mobile responsiveness for action buttons */
  .action-buttons-container {
    width: 100%;
  }

  .primary-actions {
    flex-direction: row;
    width: 100%;
  }

  .view-details-btn,
  .check-license-btn,
  .archive-btn {
    padding: 10px 16px;
  }
}

/* Additional adjustments for very small screens */
@media (max-width: 480px) {
  .staff-table-container {
    margin: 4px;
    padding: 4px;
  }

  .staff-table td {
    padding: 6px;
  }

  .actions-cell .check-license-btn,
  .actions-cell .view-details-btn,
  .actions-cell .delete-btn {
    padding: 8px;
    font-size: 0.8rem;
  }
}

/* Enhanced search section styling */
.search-section {
  margin-bottom: 24px;
  padding: 0 0 20px 0;
  border-bottom: 1px solid var(--border-color);
  width: 100%;
  display: block;
  margin-left: auto;
  margin-right: auto;
}

.table-search-input {
  width: 100%;
  max-width: 400px;
  padding: 12px 16px;
  border: 2px solid var(--border-color);
  border-radius: var(--radius-sm);
  font-size: 0.95rem;
  transition: all 0.3s ease;
  background: var(--background-light);
}

.table-search-input:focus {
  outline: none;
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.15);
  transform: translateY(-1px);
}

.table-search-input::placeholder {
  color: var(--text-secondary);
  opacity: 0.7;
}

/* Update mobile responsiveness for search */
@media (max-width: 768px) {
  .search-section {
    margin-bottom: 20px;
    padding: 0 0 16px 0;
  }

  .table-search-input {
    font-size: 0.9rem;
    padding: 10px 14px;
  }
}

/* Enhanced Button States and Animations */
.check-license-btn.success {
  background-color: var(--success-color);
}

.check-license-btn.error {
  background-color: var(--danger-color);
}

.check-license-btn.checking {
  background-color: var(--primary-dark);
}

/* Button Content Styling */
.button-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

/* Loading Spinner */
.spinner {
  width: 16px;
  height: 16px;
  border: 2px solid white;
  border-top: 2px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Success and Error Icons */
.check-icon {
  font-size: 16px;
  font-weight: bold;
  animation: bounceIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);
}

.error-icon {
  font-size: 16px;
  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;
}

/* Animations */
@keyframes bounceIn {
  0% { transform: scale(0); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

@keyframes shake {
  10%, 90% { transform: translate3d(-1px, 0, 0); }
  20%, 80% { transform: translate3d(2px, 0, 0); }
  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }
  40%, 60% { transform: translate3d(4px, 0, 0); }
}

/* Status Transitions */
.status {
  transition: all 0.3s ease;
}

.status.checking {
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% { opacity: 1; }
  50% { opacity: 0.6; }
  100% { opacity: 1; }
}

/* Mobile Responsiveness for New Elements */
@media (max-width: 768px) {
  .button-content {
    justify-content: center;
    width: 100%;
  }

  .check-license-btn,
  .view-details-btn,
  .delete-btn {
    min-width: 100%;
    padding: 10px 16px;
  }

  .spinner {
    width: 14px;
    height: 14px;
  }

  .check-icon,
  .error-icon {
    font-size: 14px;
  }
}

/* Hover Effects */
.check-license-btn:not(:disabled):hover {
  transform: none;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.check-license-btn:not(:disabled):active {
  transform: translateY(0);
}

/* Status Message Transitions */
.button-content.success,
.button-content.error {
  animation: slideIn 0.3s ease;
}

@keyframes slideIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Focus States */
.check-license-btn:focus {
  outline: none;
  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);
}

.check-license-btn.success:focus {
  box-shadow: 0 0 0 3px rgba(46, 204, 113, 0.3);
}

.archive-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* Add this to your existing actions cell styles */
.actions-cell {
  display: flex;
  gap: 8px;
  justify-content: flex-start;
  align-items: center;
  padding: 8px;
}

/* Style for the view details button to match the design */
.view-details-btn {
  padding: 8px 16px;
  border-radius: 4px;
  border: 1px solid #0d6efd;
  background-color: transparent;
  color: #0d6efd;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
}

.view-details-btn:hover {
  background-color: #0d6efd;
  color: white;
}

.view-details-btn:focus {
  outline: none;
  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25);
}

.view-details-btn:active {
  transform: scale(0.98);
}

.view-details-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.search-controls {
  display: flex;
  gap: 16px;
  align-items: center;
  margin-bottom: 20px;
}

.table-search-input {
  flex: 1 1;
  padding: 12px 16px;
  border: 2px solid #edf2f7;
  border-radius: 8px;
  font-size: 1rem;
  transition: all 0.3s ease;
}

.table-search-input:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-select {
  padding: 12px 16px;
  border: 2px solid #edf2f7;
  border-radius: 8px;
  font-size: 1rem;
  background-color: white;
  min-width: 200px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.filter-select:focus {
  outline: none;
  border-color: #3b82f6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.filter-select:hover {
  border-color: #3b82f6;
}

/* Sortable header styles */
.sortable-header {
  cursor: pointer;
  position: relative;
  -webkit-user-select: none;
          user-select: none;
  transition: background-color 0.2s ease;
}

.sortable-header:hover {
  background-color: rgba(33, 150, 243, 0.05);
}

.sortable-header:active {
  background-color: rgba(33, 150, 243, 0.1);
}

.sort-indicator {
  display: inline-block;
  margin-left: 5px;
  font-size: 0.7rem;
  color: var(--primary-color);
  transition: transform 0.2s ease;
}

/* Add a subtle indicator to show headers are clickable */
.sortable-header::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 0;
  height: 2px;
  background-color: var(--primary-color);
  transition: width 0.2s ease;
}

.sortable-header:hover::after {
  width: 80%;
}

/* Mobile responsiveness for sortable headers */
@media (max-width: 768px) {
  .sortable-header {
    padding-right: 25px; /* Make space for the indicator */
  }
  
  .sort-indicator {
    position: absolute;
    right: 8px;
    top: 50%;
    transform: translateY(-50%);
  }
}

/* Export button styles */
.export-btn {
  padding: 12px 16px;
  border-radius: 8px;
  background-color: var(--primary-color);
  color: white;
  font-size: 0.95rem;
  font-weight: 500;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 120px;
}

.export-btn:hover {
  background-color: var(--primary-dark);
  transform: translateY(-1px);
  box-shadow: var(--shadow-sm);
}

.export-btn:active {
  transform: translateY(0);
}

.export-btn:disabled {
  opacity: 0.7;
  cursor: not-allowed;
  background-color: var(--text-secondary);
}

/* Mobile responsiveness for export button */
@media (max-width: 768px) {
  .search-controls {
    flex-direction: column;
    gap: 10px;
  }
  
  .export-btn {
    width: 100%;
    padding: 10px;
  }
}

/* Column width adjustments - more balanced distribution */
.name-cell {
  width: 12%;
}

.license-number-cell {
  width: 12%;
}

.age-cell {
  width: 4%;
  min-width: 40px;
}

.status-cell {
  width: 10%;
}

.points-cell {
  width: 4%;
  min-width: 40px;
}

.date-cell {
  width: 10%;
}

.actions-cell {
  width: 12%;
}


`, "",{"version":3,"sources":["webpack://./src/components/StaffTable.css"],"names":[],"mappings":"AAAA,qCAAqC;AACrC;EACE,wBAAwB;EACxB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,2BAA2B;EAC3B,uBAAuB;EACvB,uCAAuC;EACvC,sCAAsC;EACtC,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,6BAA6B;AAC7B;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,0CAA0C;EAC1C,iBAAiB;EACjB,aAAa;EACb,+BAA+B;EAC/B,UAAU;EACV,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,OAAO;EACP,QAAQ;AACV;;AAEA;EACE,2BAA2B;AAC7B;;AAEA,2BAA2B;AAC3B;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;EACjB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qEAAqE;EACrE,aAAa;EACb,gBAAgB;EAChB,0BAA0B;EAC1B,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,yCAAyC;EACzC,0CAA0C;EAC1C,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,4CAA4C;EAC5C,sBAAsB;EACtB,YAAY;AACd;;AAEA,2BAA2B;AAC3B;EACE,iBAAiB;EACjB,mBAAmB;EACnB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA,mBAAmB;AACnB;EACE,WAAW;EACX,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;EACpB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,WAAW;AACb;;AAEA,yDAAyD;AACzD;;;EAGE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;EAChC,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,SAAO;AACT;;AAEA,gCAAgC;AAChC;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iCAAiC;AACjC;EACE,qBAAqB;EACrB,cAAc;EACd,wCAAwC;EACxC,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,wCAAwC;EACxC,qBAAqB;EACrB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA,iCAAiC;AACjC;;;EAGE,aAAa;EACb,8CAA8C;AAChD;;AAEA,kCAAkC;AAClC;;;EAGE,sBAAsB;AACxB;;AAEA,sCAAsC;AACtC;;EAEE,kBAAkB;EAClB,aAAa;EACb,4BAA4B;EAC5B,iBAAiB;EACjB,kEAAkE;EAClE,+BAA+B;EAC/B,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;EACA;IACE,0CAA0C;EAC5C;AACF;;AAEA,mCAAmC;AACnC;EACE;IACE,WAAW;IACX,YAAY;IACZ,WAAW;IACX,eAAe;IACf,sBAAsB;EACxB;;EAEA;IACE,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;;;;IAIE,cAAc;IACd,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,YAAY;IACZ,+BAA+B;IAC/B,qCAAqC;IACrC,4BAA4B;IAC5B,WAAW;IACX,sBAAsB;EACxB;;EAEA;IACE,YAAY;IACZ,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,WAAW;IACX,sBAAsB;EACxB;;EAEA,oDAAoD;EACpD;IACE,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,iBAAiB;EACnB;;EAEA;;;IAGE,WAAW;IACX,sBAAsB;IACtB,YAAY;IACZ,aAAa;IACb,SAAS;IACT,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,mBAAmB;EACrB;;EAEA,iDAAiD;EACjD;IACE,kBAAkB;EACpB;;EAEA,6CAA6C;EAC7C;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;IACnB,WAAW;EACb;;EAEA;;;IAGE,kBAAkB;EACpB;AACF;;AAEA,kDAAkD;AAClD;EACE;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;;;IAGE,YAAY;IACZ,iBAAiB;EACnB;AACF;;AAEA,oCAAoC;AACpC;EACE,mBAAmB;EACnB,mBAAmB;EACnB,4CAA4C;EAC5C,WAAW;EACX,cAAc;EACd,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,qCAAqC;EACrC,+BAA+B;EAC/B,kBAAkB;EAClB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,aAAa;EACb,kCAAkC;EAClC,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA;EACE,4BAA4B;EAC5B,YAAY;AACd;;AAEA,4CAA4C;AAC5C;EACE;IACE,mBAAmB;IACnB,mBAAmB;EACrB;;EAEA;IACE,iBAAiB;IACjB,kBAAkB;EACpB;AACF;;AAEA,0CAA0C;AAC1C;EACE,sCAAsC;AACxC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;AACvC;;AAEA,2BAA2B;AAC3B;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;AACV;;AAEA,oBAAoB;AACpB;EACE,WAAW;EACX,YAAY;EACZ,uBAAuB;EACvB,iCAAiC;EACjC,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,4BAA4B;AAC5B;EACE,eAAe;EACf,iBAAiB;EACjB,+DAA+D;AACjE;;AAEA;EACE,eAAe;EACf,wDAAwD;AAC1D;;AAEA,eAAe;AACf;EACE,KAAK,mBAAmB,EAAE;EAC1B,MAAM,qBAAqB,EAAE;EAC7B,OAAO,mBAAmB,EAAE;AAC9B;;AAEA;EACE,WAAW,kCAAkC,EAAE;EAC/C,WAAW,iCAAiC,EAAE;EAC9C,gBAAgB,kCAAkC,EAAE;EACpD,WAAW,iCAAiC,EAAE;AAChD;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,KAAK,UAAU,EAAE;EACjB,MAAM,YAAY,EAAE;EACpB,OAAO,UAAU,EAAE;AACrB;;AAEA,2CAA2C;AAC3C;EACE;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;;;IAGE,eAAe;IACf,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;;IAEE,eAAe;EACjB;AACF;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,wCAAwC;AAC1C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,+BAA+B;AAC/B;;EAEE,4BAA4B;AAC9B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,6CAA6C;AAC/C;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,kDAAkD;AAClD;EACE,aAAa;EACb,QAAQ;EACR,2BAA2B;EAC3B,mBAAmB;EACnB,YAAY;AACd;;AAEA,0DAA0D;AAC1D;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;EACzB,6BAA6B;EAC7B,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,8CAA8C;AAChD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,uBAAuB;EACvB,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,qBAAqB;AACvB;;AAEA,2BAA2B;AAC3B;EACE,eAAe;EACf,kBAAkB;EAClB,yBAAiB;UAAjB,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,2BAA2B;EAC3B,+BAA+B;AACjC;;AAEA,yDAAyD;AACzD;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,QAAQ;EACR,WAAW;EACX,sCAAsC;EACtC,2BAA2B;AAC7B;;AAEA;EACE,UAAU;AACZ;;AAEA,+CAA+C;AAC/C;EACE;IACE,mBAAmB,EAAE,iCAAiC;EACxD;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;EAC7B;AACF;;AAEA,yBAAyB;AACzB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sCAAsC;EACtC,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;EACrC,2BAA2B;EAC3B,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA,4CAA4C;AAC5C;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF;;AAEA,0DAA0D;AAC1D;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ","sourcesContent":["/* Variables for consistent theming */\n:root {\n  --primary-color: #2196f3;\n  --primary-dark: #1976d2;\n  --success-color: #2ecc71;\n  --warning-color: #f1c40f;\n  --danger-color: #e74c3c;\n  --text-primary: #2c3e50;\n  --text-secondary: #7f8c8d;\n  --background-light: #f8f9fa;\n  --border-color: #e0e0e0;\n  --shadow-sm: 0 2px 4px rgba(0,0,0,0.05);\n  --shadow-md: 0 4px 6px rgba(0,0,0,0.1);\n  --radius-sm: 4px;\n  --radius-md: 8px;\n  --radius-lg: 12px;\n}\n\n/* Enhanced table container */\n.staff-table-container {\n  background: white;\n  border-radius: var(--radius-lg);\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  margin: 28px auto;\n  padding: 28px;\n  transition: transform 0.3s ease;\n  width: 90%;\n  max-width: 1600px;\n  overflow-x: auto;\n  display: block;\n  position: relative;\n  left: 0;\n  right: 0;\n}\n\n.staff-table-container:hover {\n  transform: translateY(-2px);\n}\n\n/* Enhanced table styling */\n.staff-table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n  font-size: 0.95rem;\n  min-width: 1200px;\n  table-layout: fixed;\n  margin: 0 auto;\n}\n\n.staff-table thead th {\n  background: linear-gradient(to right, var(--background-light), white);\n  padding: 18px;\n  font-weight: 600;\n  color: var(--text-primary);\n  border-bottom: 2px solid var(--border-color);\n  transition: background-color 0.3s ease;\n}\n\n.staff-table tbody tr {\n  transition: background-color 0.3s ease;\n  position: relative;\n}\n\n.staff-table tbody tr:hover {\n  background-color: var(--background-light);\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);\n  transform: none;\n}\n\n.staff-table td {\n  padding: 16px;\n  border-bottom: 1px solid var(--border-color);\n  vertical-align: middle;\n  height: 72px;\n}\n\n/* Enhanced status badges */\n.status {\n  padding: 8px 14px;\n  border-radius: 20px;\n  font-weight: 600;\n  font-size: 0.8rem;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  transition: all 0.3s ease;\n}\n\n.status.valid {\n  background-color: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n}\n\n.status.unknown {\n  background-color: rgba(189, 195, 199, 0.15);\n  color: #7f8c8d;\n}\n\n.status.suspended {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n}\n\n.status.disqualified {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n}\n\n/* Points Indicator */\n.points {\n  padding: 4px 8px;\n  border-radius: var(--radius-sm);\n  font-weight: 500;\n  min-width: 30px;\n  text-align: center;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.points.low {\n  background-color: rgba(46, 204, 113, 0.15);\n  color: #27ae60;\n}\n\n.points.medium {\n  background-color: rgba(241, 196, 15, 0.15);\n  color: #f39c12;\n}\n\n.points.high {\n  background-color: rgba(231, 76, 60, 0.15);\n  color: #c0392b;\n}\n\n/* Action Buttons */\n.actions-cell {\n  width: auto;\n  min-width: 200px;\n  padding: 8px 16px 8px 8px;\n  white-space: nowrap;\n}\n\n/* Update the action buttons container */\n.action-buttons-container {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  align-items: stretch;\n  max-width: 180px;\n  margin-right: auto;\n}\n\n.primary-actions {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-start;\n  width: 100%;\n}\n\n/* Update all action buttons to have consistent styling */\n.view-details-btn,\n.check-license-btn,\n.archive-btn {\n  padding: 8px 12px;\n  border-radius: 4px;\n  background-color: transparent;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  border: 1px solid;\n  min-width: 70px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n}\n\n/* View Details button styling */\n.view-details-btn {\n  border-color: #0d6efd;\n  color: #0d6efd;\n}\n\n.view-details-btn:hover {\n  background-color: #0d6efd;\n  color: white;\n}\n\n/* Check License button styling */\n.check-license-btn {\n  border-color: #198754;\n  color: #198754;\n  background-color: transparent !important;\n  width: 100%;\n}\n\n.check-license-btn:hover {\n  background-color: #198754 !important;\n  color: white;\n}\n\n.check-license-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n  background-color: transparent !important;\n  border-color: #6c757d;\n  color: #6c757d;\n}\n\n/* Archive button styling */\n.archive-btn {\n  border-color: #dc3545;\n  color: #dc3545;\n}\n\n.archive-btn:hover {\n  background-color: #dc3545;\n  color: white;\n}\n\n/* Focus states for all buttons */\n.view-details-btn:focus,\n.check-license-btn:focus,\n.archive-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25);\n}\n\n/* Active states for all buttons */\n.view-details-btn:active,\n.check-license-btn:active,\n.archive-btn:active {\n  transform: scale(0.98);\n}\n\n/* Enhanced loading and empty states */\n.loading-spinner,\n.no-data {\n  text-align: center;\n  padding: 60px;\n  color: var(--text-secondary);\n  font-size: 1.1rem;\n  background: linear-gradient(45deg, var(--background-light), white);\n  border-radius: var(--radius-lg);\n  margin: 28px;\n  animation: pulse 2s infinite;\n}\n\n@keyframes pulse {\n  0% {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  }\n  50% {\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.12);\n  }\n  100% {\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);\n  }\n}\n\n/* Enhanced mobile responsiveness */\n@media (max-width: 768px) {\n  .staff-table-container {\n    margin: 8px;\n    padding: 8px;\n    width: auto;\n    max-width: 100%;\n    box-sizing: border-box;\n  }\n\n  .staff-table {\n    font-size: 0.85rem;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .staff-table thead {\n    display: none;\n  }\n\n  .staff-table, \n  .staff-table tbody, \n  .staff-table tr, \n  .staff-table td {\n    display: block;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .staff-table tr {\n    margin-bottom: 16px;\n    padding: 8px;\n    border-radius: var(--radius-md);\n    border: 1px solid var(--border-color);\n    box-shadow: var(--shadow-sm);\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  .staff-table td {\n    padding: 8px;\n    height: auto;\n    min-height: 40px;\n    position: relative;\n    width: 100%;\n    box-sizing: border-box;\n  }\n\n  /* Completely restructured actions cell for mobile */\n  td.actions-cell {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    padding: 8px;\n    width: 100%;\n    box-sizing: border-box;\n    overflow: visible;\n  }\n\n  .actions-cell .check-license-btn,\n  .actions-cell .view-details-btn,\n  .actions-cell .delete-btn {\n    width: 100%;\n    box-sizing: border-box;\n    min-width: 0;\n    padding: 10px;\n    margin: 0;\n    font-size: 0.85rem;\n  }\n\n  .actions-cell .button-content {\n    width: auto;\n    min-width: 0;\n    justify-content: center;\n    white-space: normal;\n  }\n\n  /* Ensure no horizontal scroll on the container */\n  .staff-table-container {\n    overflow-x: hidden;\n  }\n\n  /* Mobile responsiveness for action buttons */\n  .action-buttons-container {\n    width: 100%;\n  }\n\n  .primary-actions {\n    flex-direction: row;\n    width: 100%;\n  }\n\n  .view-details-btn,\n  .check-license-btn,\n  .archive-btn {\n    padding: 10px 16px;\n  }\n}\n\n/* Additional adjustments for very small screens */\n@media (max-width: 480px) {\n  .staff-table-container {\n    margin: 4px;\n    padding: 4px;\n  }\n\n  .staff-table td {\n    padding: 6px;\n  }\n\n  .actions-cell .check-license-btn,\n  .actions-cell .view-details-btn,\n  .actions-cell .delete-btn {\n    padding: 8px;\n    font-size: 0.8rem;\n  }\n}\n\n/* Enhanced search section styling */\n.search-section {\n  margin-bottom: 24px;\n  padding: 0 0 20px 0;\n  border-bottom: 1px solid var(--border-color);\n  width: 100%;\n  display: block;\n  margin-left: auto;\n  margin-right: auto;\n}\n\n.table-search-input {\n  width: 100%;\n  max-width: 400px;\n  padding: 12px 16px;\n  border: 2px solid var(--border-color);\n  border-radius: var(--radius-sm);\n  font-size: 0.95rem;\n  transition: all 0.3s ease;\n  background: var(--background-light);\n}\n\n.table-search-input:focus {\n  outline: none;\n  border-color: var(--primary-color);\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.15);\n  transform: translateY(-1px);\n}\n\n.table-search-input::placeholder {\n  color: var(--text-secondary);\n  opacity: 0.7;\n}\n\n/* Update mobile responsiveness for search */\n@media (max-width: 768px) {\n  .search-section {\n    margin-bottom: 20px;\n    padding: 0 0 16px 0;\n  }\n\n  .table-search-input {\n    font-size: 0.9rem;\n    padding: 10px 14px;\n  }\n}\n\n/* Enhanced Button States and Animations */\n.check-license-btn.success {\n  background-color: var(--success-color);\n}\n\n.check-license-btn.error {\n  background-color: var(--danger-color);\n}\n\n.check-license-btn.checking {\n  background-color: var(--primary-dark);\n}\n\n/* Button Content Styling */\n.button-content {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 8px;\n}\n\n/* Loading Spinner */\n.spinner {\n  width: 16px;\n  height: 16px;\n  border: 2px solid white;\n  border-top: 2px solid transparent;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Success and Error Icons */\n.check-icon {\n  font-size: 16px;\n  font-weight: bold;\n  animation: bounceIn 0.5s cubic-bezier(0.68, -0.55, 0.265, 1.55);\n}\n\n.error-icon {\n  font-size: 16px;\n  animation: shake 0.5s cubic-bezier(.36,.07,.19,.97) both;\n}\n\n/* Animations */\n@keyframes bounceIn {\n  0% { transform: scale(0); }\n  50% { transform: scale(1.2); }\n  100% { transform: scale(1); }\n}\n\n@keyframes shake {\n  10%, 90% { transform: translate3d(-1px, 0, 0); }\n  20%, 80% { transform: translate3d(2px, 0, 0); }\n  30%, 50%, 70% { transform: translate3d(-4px, 0, 0); }\n  40%, 60% { transform: translate3d(4px, 0, 0); }\n}\n\n/* Status Transitions */\n.status {\n  transition: all 0.3s ease;\n}\n\n.status.checking {\n  animation: pulse 1.5s infinite;\n}\n\n@keyframes pulse {\n  0% { opacity: 1; }\n  50% { opacity: 0.6; }\n  100% { opacity: 1; }\n}\n\n/* Mobile Responsiveness for New Elements */\n@media (max-width: 768px) {\n  .button-content {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .check-license-btn,\n  .view-details-btn,\n  .delete-btn {\n    min-width: 100%;\n    padding: 10px 16px;\n  }\n\n  .spinner {\n    width: 14px;\n    height: 14px;\n  }\n\n  .check-icon,\n  .error-icon {\n    font-size: 14px;\n  }\n}\n\n/* Hover Effects */\n.check-license-btn:not(:disabled):hover {\n  transform: none;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.check-license-btn:not(:disabled):active {\n  transform: translateY(0);\n}\n\n/* Status Message Transitions */\n.button-content.success,\n.button-content.error {\n  animation: slideIn 0.3s ease;\n}\n\n@keyframes slideIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Focus States */\n.check-license-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 3px rgba(33, 150, 243, 0.3);\n}\n\n.check-license-btn.success:focus {\n  box-shadow: 0 0 0 3px rgba(46, 204, 113, 0.3);\n}\n\n.archive-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* Add this to your existing actions cell styles */\n.actions-cell {\n  display: flex;\n  gap: 8px;\n  justify-content: flex-start;\n  align-items: center;\n  padding: 8px;\n}\n\n/* Style for the view details button to match the design */\n.view-details-btn {\n  padding: 8px 16px;\n  border-radius: 4px;\n  border: 1px solid #0d6efd;\n  background-color: transparent;\n  color: #0d6efd;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n}\n\n.view-details-btn:hover {\n  background-color: #0d6efd;\n  color: white;\n}\n\n.view-details-btn:focus {\n  outline: none;\n  box-shadow: 0 0 0 2px rgba(13, 110, 253, 0.25);\n}\n\n.view-details-btn:active {\n  transform: scale(0.98);\n}\n\n.view-details-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.search-controls {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n  margin-bottom: 20px;\n}\n\n.table-search-input {\n  flex: 1;\n  padding: 12px 16px;\n  border: 2px solid #edf2f7;\n  border-radius: 8px;\n  font-size: 1rem;\n  transition: all 0.3s ease;\n}\n\n.table-search-input:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filter-select {\n  padding: 12px 16px;\n  border: 2px solid #edf2f7;\n  border-radius: 8px;\n  font-size: 1rem;\n  background-color: white;\n  min-width: 200px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.filter-select:focus {\n  outline: none;\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);\n}\n\n.filter-select:hover {\n  border-color: #3b82f6;\n}\n\n/* Sortable header styles */\n.sortable-header {\n  cursor: pointer;\n  position: relative;\n  user-select: none;\n  transition: background-color 0.2s ease;\n}\n\n.sortable-header:hover {\n  background-color: rgba(33, 150, 243, 0.05);\n}\n\n.sortable-header:active {\n  background-color: rgba(33, 150, 243, 0.1);\n}\n\n.sort-indicator {\n  display: inline-block;\n  margin-left: 5px;\n  font-size: 0.7rem;\n  color: var(--primary-color);\n  transition: transform 0.2s ease;\n}\n\n/* Add a subtle indicator to show headers are clickable */\n.sortable-header::after {\n  content: '';\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 0;\n  height: 2px;\n  background-color: var(--primary-color);\n  transition: width 0.2s ease;\n}\n\n.sortable-header:hover::after {\n  width: 80%;\n}\n\n/* Mobile responsiveness for sortable headers */\n@media (max-width: 768px) {\n  .sortable-header {\n    padding-right: 25px; /* Make space for the indicator */\n  }\n  \n  .sort-indicator {\n    position: absolute;\n    right: 8px;\n    top: 50%;\n    transform: translateY(-50%);\n  }\n}\n\n/* Export button styles */\n.export-btn {\n  padding: 12px 16px;\n  border-radius: 8px;\n  background-color: var(--primary-color);\n  color: white;\n  font-size: 0.95rem;\n  font-weight: 500;\n  border: none;\n  cursor: pointer;\n  transition: all 0.2s ease-in-out;\n  white-space: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-width: 120px;\n}\n\n.export-btn:hover {\n  background-color: var(--primary-dark);\n  transform: translateY(-1px);\n  box-shadow: var(--shadow-sm);\n}\n\n.export-btn:active {\n  transform: translateY(0);\n}\n\n.export-btn:disabled {\n  opacity: 0.7;\n  cursor: not-allowed;\n  background-color: var(--text-secondary);\n}\n\n/* Mobile responsiveness for export button */\n@media (max-width: 768px) {\n  .search-controls {\n    flex-direction: column;\n    gap: 10px;\n  }\n  \n  .export-btn {\n    width: 100%;\n    padding: 10px;\n  }\n}\n\n/* Column width adjustments - more balanced distribution */\n.name-cell {\n  width: 12%;\n}\n\n.license-number-cell {\n  width: 12%;\n}\n\n.age-cell {\n  width: 4%;\n  min-width: 40px;\n}\n\n.status-cell {\n  width: 10%;\n}\n\n.points-cell {\n  width: 4%;\n  min-width: 40px;\n}\n\n.date-cell {\n  width: 10%;\n}\n\n.actions-cell {\n  width: 12%;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
